<template>
<!-- 兑换记录 -->
<section class="viewContainer">
  <!-- 搜索/查询 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left: 20px; margin-top: 5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt/></span>
      </div>
      <div style="position: absolute; right: 0; top: -10px" class="sanjiao"/>
    </div>
    <!-- 顶部搜索框 -->
    <el-collapse-transition>
    <div v-show="show3">
      <el-form :model="filters" class="findform">
        <el-form-item label="关 键 字：" style="width: 20%; display: flex">
          <el-input v-model="filters.orderNo" placeholder="请输入客户手机号或订单号" maxlength="20" style="width:90%;"/>
        </el-form-item>
        <el-form-item label="品 类：" style="width: 20%; display: flex">
          <el-select v-model="filters.brandTypeId" placeholder="请选择品类" filterable @change="getbrandarr" style="width:90%;">
            <el-option v-for="(item, index) in brandTypearr" :key="index" :label="item.Name" :value="item.Id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="品 牌：" style="width: 20%; display: flex">
          <el-select v-model="filters.brandId" placeholder="请选择品牌" filterable style="width:90%;">
            <el-option v-for="(item, index) in brandarr" :key="index" :label="item.Name" :value="item.Id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="状   态：" style="width: 20%; display: flex">
          <el-select v-model="filters.biddingStatusId" placeholder="请选择状态" filterable style="width:90%;">
            <el-option v-for="(item, index) in chooseStateList" :key="index" :label="item.Name" :value="item.Id"/>
          </el-select>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">兑换记录</p>
    </section>
    <!-- table 列表 -->
    <div class="table_container">
      <el-table :data="dataList" stripe border>
        <el-table-column label="序号" align="center" width="68px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="订单号" align="center">
          <template scope="scope">
            <span :title="scope.row.orderNo" :label="scope.row.orderNo">{{ scope.row.orderNo }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户昵称" align="center">
          <template scope="scope">
            <span :title="scope.row.userName" :label="scope.row.userName">{{ scope.row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" align="center">
          <template scope="scope">
            <span :title="scope.row.userPhone" :label="scope.row.userPhone">{{ scope.row.userPhone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="品类" align="center">
          <template scope="scope">
            <span :title="scope.row.goodsBrandTypeName" :label="scope.row.goodsBrandTypeName">
              {{ scope.row.goodsBrandTypeName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="品牌" align="center">
          <template scope="scope">
            <span :title="scope.row.brandName" :label="scope.row.brandName">{{ scope.row.brandName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品名称" align="center">
          <template scope="scope">
            <span :title="scope.row.goodsName" :label="scope.row.goodsName">{{ scope.row.goodsName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="消费积分" align="center">
          <template scope="scope">
            <span :title="scope.row.integral" :label="scope.row.integral">{{ scope.row.integral }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template scope="scope">
            <span :title="scope.row.stateName" :label="scope.row.stateName">{{ scope.row.stateName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span v-if="scope.row.type!=3" @click="seeOrder(scope.row.id,scope.row.state)"
              class="handle" style="margin-right: 5px">
              <i class="el-icon-view"></i>查看
            </span>
            <span @click="deliverGoodsFn(scope.row.id)" class="handle" v-if="scope.row.state==1">
              <i class="el-icon-truck"></i>发货
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="total" style="margin: 10px 0; float: right"/>
    </div>
  </div>

  <!-- 抽屉详情 size="50%" -->
  <el-drawer :visible.sync="orderDetails" :show-close="false" size="35%">
    <template v-slot:title>
      <ul class="drawer_title">
        <li>订单详情</li>
        <li>
          <el-button type="danger" @click="cancelDrawer" style="margin-top: -10px">关 闭</el-button>
        </li>
      </ul>
    </template>
    <div class="drawer_div">
      <!-- 订单信息 -->
      <div class="drawerDiv deliverDetails">
        <p>用户信息</p>
        <ul>
          <li>
            换购人：<span>{{integralDet.userName}}</span>
          </li>
          <li>
            手机号：<span>{{integralDet.userPhone}}</span>
          </li>
          <li v-if="integralDet.deliveryMode==1 && integralDet.type==1">
            收货人姓名：<span>{{integralDet.consigneeName}}</span>
          </li>
          <li v-if="integralDet.deliveryMode==1  && integralDet.type==1">
            手机号：<span>{{integralDet.consigneePhone}}</span>
          </li>
          <li class="maxWidth" v-if="integralDet.deliveryMode==1  && integralDet.type==1">
            收货地址：<span>{{integralDet.consigneeAddress}}</span>
          </li>
        </ul>

        <p>商品信息</p>
        <ul>
          <div class="leftImgRigText">
            <div class="imgBox" v-if="integralDet.type==1">
              <img :src="integralDet.imgUrl" alt="" />
            </div>
            <div class="drawerDiv">
              <ul>
                <li>商品名称：<span>{{integralDet.goodsName}}</span></li>
                <li>品类：<span>{{integralDet.goodsBrandTypeName}}</span></li>
                <li>品牌：<span>{{integralDet.brandName}}</span></li>
              </ul>
            </div>
          </div>
        </ul>

        <p>订单信息</p>
        <!-- 1 未发货 2 未取货  3 已发货  4 已完成 5 已取货 6 已到账 -->
        <ul>
          <li  class="maxWidth">订单号：<span>{{integralDet.orderNo}}</span></li>
          <li>订单状态：<span>{{integralDet.stateName}}</span></li>
          <li v-if="integralDet.deliveryMode==1  && integralDet.type==1">
            运费：<span>{{ integralDet.freight }}元</span>
          </li>
          <li>
            订单总价：<span>{{integralDet.price }}元</span>
          </li>
          <li>消费积分：<span>{{integralDet.integral}}</span></li>
          <li  class="maxWidth" >换购时间：<span>{{integralDet.cTime}}</span></li>
          <li  class="maxWidth" v-if="integralDet.deliveryMode==1 && integralDet.type==1 && detStateId>2">
            发货时间：<span>{{integralDet.expressTime}}</span>
          </li>
          <li  class="maxWidth" v-if="integralDet.deliveryMode==1  && integralDet.type==1">
            物流信息：
            <span v-if="detStateId == 1">未发货，无物流信息</span>
            <span v-else>{{integralDet.expressName}}，单号：{{integralDet.expressOrderNo}}</span>
          </li>
          <li  class="maxWidth" v-if="detStateId >= 4 && integralDet.type==1">完成时间：<span>{{integralDet.completeTime}}</span></li>
        </ul>
      </div>
    </div>
  </el-drawer>
  <!-- 发货弹框 -->
  <el-dialog title="物流发货" :visible.sync="deliverGoodsSettings" width="30%"
    class="add_order_cancle" @close="canceldeliverGoodsFun()">
    <el-form :model="deliverGoods" ref="deliverGoods" label-width="80px" class="demo-ruleForm">
      <el-row :gutter="20">
        <el-col :span="19">
          <el-form-item label="物流公司:" prop="groupModeId">
            <el-select v-model="deliverGoods.groupModeId" filterable placeholder="请选择物流公司" style="width: 100%">
              <el-option v-for="(item, index) in logisticsCompanyList" :key="index" :value="item.Name" :label="item.Name"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 物流单号 -->
      <el-row :gutter="20">
        <el-col :span="19">
          <!-- 新用户首单 -->
          <el-form-item label="物流单号:" prop="groupNumber">
            <el-input v-model="deliverGoods.groupNumber" placeholder="请输入物流单号" minlength="5" maxlength="30"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="padding-left: 0; text-align: center; margin-top: 25px">
      <el-button @click="canceldeliverGoodsFun()">取消</el-button>
      <el-button type="danger" @click="editDeliverGoodsSubmit()">发货</el-button>
    </div>
  </el-dialog>
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { SelectBrandTypeBaseDataByCondition } from '../../api/newOss';
import { getkind, getProvinceAndCityAndZoneByDataType, SelectGoodsBrandByBrandType, } from "../../api/api";
import { getBaseDataList, IntegralExchangeOrderRecord,
UpdateExchangeOrderLogisticsInfo,GetIntegralExchangeRecordListById } from "../../api/shopWindow";
export default {
  name: "ExchangeRecords",
  mixins: [alertTrends],
  data() {
    return {
      show3: true,
      deliverGoods: {
        groupModeId: "", //物流公司
        groupNumber: "", //物流单号
      },
      detStateId: null,
      deliverGoodsSettings: false,
      integralDet: {}, //积分详情
      //状态基础数据
      groupTypeList: [
        {
          Value: 1,
          Name: "开启",
        },
        {
          Value: 2,
          Name: "关闭",
        },
      ],
      orderDetails: false,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      timer: null,
      dataList: [], // 查询列表

      // 所属城市
      provinceId: 0,
      cityId: 0,
      zoneId: 0,
      options: [],
      detailList: {
        StatusName: "sdsd",
        InquiryZone: "sdsd",
      },
      logisticsCompanyList: [],     // 物流公司
      chooseStateList: [],   // 选择状态
      brandTypearr: [], // 询价品类
      brandarr: [], // 意向品牌
      filters: {
        orderNo: "", // 询价单号
        biddingStatusId:0, // 状态ID
        styleId: 0, // 风格
        brandTypeId: "", // 询价品类
        brandId: "", // 意向品牌
      },
      queryId: "",
    };
  },
  methods: {
    // 关闭抽屉弹框
    cancelDrawer() {
      this.orderDetails = false;
    },
    // 发货弹框关闭
    canceldeliverGoodsFun() {
      this.deliverGoodsSettings = false;
      this.$refs.deliverGoods.resetFields();
    },
    // 发货弹框确定
    editDeliverGoodsSubmit() {
      if (!this.deliverGoods.groupModeId) {
        this.showAlert('请选择物流公司');
        return false;
      }
      if (!this.deliverGoods.groupNumber) {
        this.showAlert('请输入物流单号');
        return false;
      }

      if (
        this.deliverGoods.groupNumber.length < 5 ||
        this.deliverGoods.groupNumber.length > 30
      ) {
        this.showAlert('物流单号长度在 5 到 30 个字符');
        return false;
      }
      let params = {
        operatorId: localStorage.Id,
        exchangeRecordId: this.chooseDetId,
        logisticsCompanyName: this.deliverGoods.groupModeId,
        logisticNumber: this.deliverGoods.groupNumber,
      };
      UpdateExchangeOrderLogisticsInfo(params).then((res) => {
        // 成功后的操作 清空表单并关闭弹框
        if (res.ResultCode == 1) {
          this.showAlert('操作成功', 'success');
        }
        this.canceldeliverGoodsFun();
        this.init();
      });
    },

    // 查看
    seeOrder(id,state) {
      this.orderDetails = true;
      this.chooseDetId=id;
      this.detStateId=state;
      let params = {
        exchangeRecordId:this.chooseDetId
      };
      GetIntegralExchangeRecordListById(params).then((res) => {
        this.integralDet = res.ResultObj || {};
      });
    },
    // 发货
    deliverGoodsFn(id) {
      this.chooseDetId=id;
      this.deliverGoodsSettings = true;
    },
    //产品风格
    getstyle() {
      let that = this;
      var loginParams = {
        tableName: "tBD柜_风格",
        keyWord: "",
        parentId: "",
      };
      getkind(loginParams).then((data) => {
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部",
        };
        data.unshift(obj);
        that.stylearr = data;
      });
    },

    //获取品牌
    getbrandarr() {
      this.filters.brandId = 0;
      var obj = {
        userId: localStorage.Id,
        brandTypeId: this.filters.brandTypeId,
      };
      SelectGoodsBrandByBrandType(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.brandarr = data.ResultObj;
          this.brandarr.unshift({
            Id: 0,
            Name: "全部",
          });
        }
      });
    },
    //获取品类
    getBrandType() {
      var obj = {
        userId: localStorage.Id,
      };
      SelectBrandTypeBaseDataByCondition(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.brandTypearr = data.ResultObj;
          this.newpinleioptions = data.ResultObj;
          this.brandTypearr.unshift({
            Id: 0,
            Name: "全部",
          });
        }
      });
    },
    // 意向品牌
    getpinpai() {
      let that = this;
      var loginParams = {
        tableName: "tbdbrand",
        keyWord: "",
        parentId: "",
      };
      getkind(loginParams).then((data) => {
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部",
        };
        data.unshift(obj);
        that.brandarr = data;
      });
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
      this.zoneId = val[2];
    },
    // 查找省+市+区
    getprovince() {
      var loginParams = {
        isOpen: 1,
        dataLevel: 3,
      };
      getProvinceAndCityAndZoneByDataType(loginParams).then((data) => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.ResultObj.map((item) => {
          // 所有省 查当前省下级市
          let provinceData = { value: item.Id, label: item.Name, children: [] };
          provinceAndCityAndarea.push(provinceData);
          // 所有市
          item.CityList.map((city) => {
            let cityData = { value: city.Id, label: city.Name, children: [] };
            provinceData.children.push(cityData);
            // 区
            city.ZoneList.map((zone) => {
              cityData.children.push({ value: zone.Id, label: zone.Name });
            });
          });
        });
        that.options = provinceAndCityAndarea;
      });
    },
    // 重置
    fnReset() {
      this.filters = {
        orderNo: "", // 询价单号
        chengshi: "", // 询价城市
        biddingStatusId: 0, // 状态ID
        roomId: 0, // 室
        officeId: -1, // 厅
        kitchenId: -1, // 厨
        toiletId: -1, // 卫
        styleId: 0, // 风格
        minPurchasingPrice: "", // 最低预算
        maxPurchasingPrice: "", // 最高预算
        brandTypeId: "", // 询价品类
        brandId: "", // 意向品牌
      };
      this.provinceId = 0;
      this.cityId = 0;
      this.zoneId = 0;
      this.queryId = "";
      // this.pageIndex = 1;
      // this.getorder();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.init();
    },
    refresh() {
      this.getorder();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    init() {
      let params = {
        userId: localStorage.Id,
        keyword: this.filters.orderNo,
        goodsBrandTypeId: this.filters.brandTypeId,
        brandId: this.filters.brandId,
        state: this.filters.biddingStatusId,
        pageIndex: this.pageIndex,
        pageSize: 10,
      };
      IntegralExchangeOrderRecord(params).then((res) => {
        if (res.ResultCode == 1) {
          this.dataList = res.ResultObj;
          this.total = res.RowsCount;
        }else if (res.ResultCode == 4) {
          this.dataList =[];
          this.total = 0;
        }
      });
    },
    // 状态列表
    stateList() {
      let params = {
        tabName: "tBDIntegralGoodsOrderState",
      };
      getBaseDataList(params).then((res) => {
          var obj = {
            Id: 0,
            Name: "全部",
          };
          res.unshift(obj);
         this.chooseStateList=res;
      });
    },
    // 物流公司列表
    logisticsCompany() {
      let params = {
        tabName: "tBDLogisticsCompany",
      };
      getBaseDataList(params).then((res) => {
        // if (res.ResultCode == 1) {
          this.logisticsCompanyList=res||[];
        // }
      });
    },
  },
  created() {
    this.init();
    this.stateList();
    this.logisticsCompany();
    this.getBrandType(); //获取品类
  },
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// ExchangeRecords.vue?0842a287